<template>
  <div class="strates">
    <div v-for="(strate, index) in data" class="strates__container u-w12of12"
    :class="{
      'u-bg-blue': strate.backgroundColored,
      'u-pad-t-xl u-marg-t-xl u-pad-t-md--sm u-marg-t-md--sm': strate.backgroundColored && index > 0 && !data[index-1].backgroundColored,
      'u-pad-b-xl u-marg-b-xl u-pad-b-md--sm u-marg-b-md--sm': (strate.backgroundColored && index < data.length-1 && !data[index+1].backgroundColored) || strate.backgroundColored && index === data.length-1
    }">
      <highlighted v-if="strate.typeHandle === 'highlighted'" :data="strate" />
      <hook-text v-if="strate.typeHandle === 'hooktext'" :data="strate" />
      <hook-numbers v-if="strate.typeHandle === 'hooknumber'" :data="strate" />
      <feature v-if="strate.typeHandle === 'feature'" :data="strate" />
      <list-items v-if="strate.typeHandle === 'listitems'" :data="strate" />
      <media v-if="strate.typeHandle === 'media'" :data="strate" />
      <app-audio v-if="strate.typeHandle === 'audio'" :data="strate" />
      <list-logos v-if="strate.typeHandle === 'listlogos'" :data="strate" /> 
      <testimonials v-if="strate.typeHandle === 'testimonials'" :data="global.brightTestimonials" />
      <testimonial-card v-if="strate.typeHandle === 'testimonialCustom'" :data="strate" />
      <slider-relatives v-if="strate.typeHandle === 'sliderRelatives'" :data="strate" />
      <slider v-if="strate.typeHandle === 'slider'" :data="strate" />
      <hubspot-form v-if="strate.typeHandle === 'form'" :data="strate" />
      <cta v-if="strate.typeHandle === 'cta'" :data="strate" />
      <image-text v-if="strate.typeHandle === 'imageText'" :data="strate" />
      <double-image-label v-if="strate.typeHandle === 'doubleImageLabel'" :data="strate" />
      <triptych v-if="strate.typeHandle === 'triptych'" :data="strate" />
      <quote v-if="strate.typeHandle === 'quote'" :data="strate" />
      <contact v-if="strate.typeHandle === 'contact'" />
      <big-title v-if="strate.typeHandle === 'bigTitle'" :data="strate" />
      <embed-content v-if="strate.typeHandle === 'embedContent'" :data="strate" />
      <social-media v-if="strate.typeHandle === 'socialMedia'" :data="strate" class="u-center u-pad-md"/>
    </div>
  </div>
</template>

<script>

import Highlighted from '@/components/strates/Highlighted'
import HookText from '@/components/strates/HookText'
import Feature from '@/components/strates/Feature'
import HookNumbers from '@/components/strates/HookNumbers'
import ListItems from '@/components/strates/ListItems'
import Media from '@/components/strates/Media'
import Testimonials from '@/components/strates/Testimonials'
import TestimonialCard from '@/components/strates/TestimonialCard'
import ListLogos from '@/components/strates/ListLogos'
import AppAudio from '@/components/strates/AppAudio'
import Slider from '@/components/strates/Slider'
import SliderRelatives from '@/components/strates/SliderRelatives'
import HubspotForm from '@/components/strates/HubspotForm'
import Cta from '@/components/strates/Cta'
import ImageText from '@/components/strates/ImageText'
import DoubleImageLabel from '@/components/strates/DoubleImageLabel'
import Triptych from '@/components/strates/Triptych'
import Quote from '@/components/strates/Quote'
import Contact from '@/components/strates/Contact'
import BigTitle from '@/components/strates/BigTitle'
import EmbedContent from '@/components/strates/EmbedContent'
import SocialMedia from '@/components/strates/SocialMedia'

export default {
  props: {
    data: {
      type: Array,
      default: () => {return []}
    }
  },

  components: {
    Highlighted,
    HookText,
    Feature,
    HookNumbers,
    ListItems,
    Media,
    Testimonials,
    TestimonialCard,
    ListLogos,
    AppAudio,
    SliderRelatives,
    Slider,
    HubspotForm,
    Cta,
    ImageText,
    DoubleImageLabel,
    Triptych,
    Quote,
    Contact,
    BigTitle,
    EmbedContent,
    SocialMedia
  },

  computed: {
    global () {
      return this.$store.getters['data/global']
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/mixins/mq'

.strates
  &__container
    margin 0 auto
    max-width bp-wide


</style>
